import { env } from '@/env'

import { ApiClient } from './generated-api-and-types'
import { YouTubeVideo } from './types/YouTubeVideo'
import { YouTubeVideoError } from './types/YouTubeVideoError'

const { MODE, REACT_APP_PROXY, REACT_APP_SUBDOMAIN, REACT_APP_API_SUBDOMAIN } =
  env

export class ApiClientExtended extends ApiClient<any> {
  extended = {
    youtubeVideoGetByVideoId: (videoId: string) => {
      const youtubeLambdaUrl = `${
        MODE === 'development'
          ? REACT_APP_PROXY
          : window.location.origin
              .replace('http://', 'https://')
              .replace(
                `https://${REACT_APP_SUBDOMAIN}.`,
                `https://${REACT_APP_API_SUBDOMAIN}.`,
              )
      }/api-lambda/embedded-video-info?url=https://www.youtube.com/watch?v=${videoId}`

      return this.request<YouTubeVideo, YouTubeVideoError>({
        path: youtubeLambdaUrl,
        method: 'GET',
        format: 'json',
      })
    },
  }
}
